"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("../Button/Button"));
const Card_1 = __importDefault(require("../Card/Card"));
const Overlay_1 = __importDefault(require("../Internals/Overlay"));
const SimpleLink_1 = __importDefault(require("../SimpleLink/SimpleLink"));
const useHotkey_1 = require("../useHotkey");
const styled_1 = __importDefault(require("../utils/styled"));
const Actions = styled_1.default("div") `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const Container = styled_1.default(Card_1.default) `
  position: fixed;
  padding: ${({ theme }) => theme.space.content}px;
  top: ${({ center }) => (center ? "50%" : "auto")};
  right: ${({ center }) => (center ? 0 : "40px")};
  bottom: ${({ center }) => (center ? "auto" : "40px")};
  left: ${({ center }) => (center ? 0 : "auto")};
  margin: ${({ center }) => (center ? "0 auto" : 0)};
  transform: ${({ center }) => (center ? "translateY(-50%)" : "none")};
  z-index: ${({ theme }) => theme.zIndex.modal};
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.32);
  max-width: ${({ center }) => (center ? 767 : 465)}px;
`;
const Content = styled_1.default("div") `
  display: flex;
`;
const LeftColumn = styled_1.default("div") `
  width: 30%;
  height: auto;
  max-width: 175px;
  border-right: 2px solid rgba(0, 0, 0, 0.1);
  margin-right: ${({ theme }) => theme.space.element}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
const ChildrenContainer = styled_1.default("div") `
  width: 100%;
`;
const TourOverlay = styled_1.default(Overlay_1.default) `
  opacity: 0.4;
  animation: none;
`;
const TourModal = ({ center, image, children, onQuit, onContinue, isLast, messages = { quit: "Quit the Tour", finish: "Finish", continue: "Continue" }, }) => {
    const $body = React.useRef(document.body);
    useHotkey_1.useHotkey($body, { key: "Escape" }, () => {
        if (onQuit && !isLast) {
            onQuit();
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(TourOverlay, null),
        React.createElement(Container, { "data-cy": "operational-ui-TourModal", center: center || false },
            React.createElement(Content, null,
                image && (React.createElement(LeftColumn, null,
                    image,
                    center && onQuit && React.createElement(SimpleLink_1.default, { onClick: onQuit }, messages.quit))),
                React.createElement(ChildrenContainer, null,
                    children,
                    React.createElement(Actions, { center: center || false },
                        !center && onQuit && React.createElement(Button_1.default, { onClick: onQuit }, messages.quit),
                        onContinue && (React.createElement(Button_1.default, { "aria-label": isLast ? messages.finish : messages.continue, onClick: onContinue, color: "primary" }, isLast ? messages.finish : messages.continue))))))));
};
exports.default = TourModal;
//# sourceMappingURL=TourModal.js.map